import { useState } from "react";

import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import InclusionSdkChip from "app/pages/sales-intelligence/modules/apps-search-filters/components/InclusionSdkChip/InclusionSdkChip";
import SdkModal from "app/pages/sales-intelligence/modules/apps-search-filters/components/modals/SdkModal/SdkModal";
import type { AppsSDKsFilterDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import { hasSameSdkObject } from "app/pages/sales-intelligence/modules/find-apps-filters/utils";
import type { IAppsSDKsFilterItem } from "app/pages/sales-intelligence/store/find-apps/types";
import { operatorOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

import { StyledSDKValueDivider } from "./styles";

const AppSdkFilterResult = ({
    filter,
    value = [],
    onFilterUpdate,
}: IFilterViewBaseModelProps<IAppsSDKsFilterItem[], AppsSDKsFilterDescriptionDto>) => {
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<IAppsSDKsFilterItem | null>(null);

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleApply = (item: IAppsSDKsFilterItem, selectedItem?: IAppsSDKsFilterItem) => {
        const sdkValues = (value || []).map((sdkItem: IAppsSDKsFilterItem) => {
            if (selectedItem && hasSameSdkObject(sdkItem, selectedItem)) {
                return item;
            }

            return sdkItem;
        });
        onFilterUpdate(sdkValues);
        setIsOpenModal(false);
    };

    const handleOnDelete = (selectedItem: IAppsSDKsFilterItem) => {
        const filteredSdks = value?.filter((item: IAppsSDKsFilterItem) => !hasSameSdkObject(item, selectedItem));
        onFilterUpdate(filteredSdks && filteredSdks.length > 0 ? filteredSdks : undefined);
    };

    const handleOnEdit = (selectedItem: IAppsSDKsFilterItem) => {
        setSelectedItem(selectedItem);
        setIsOpenModal(true);
    };

    if (value?.length === 0) {
        return null;
    }

    return (
        <div>
            <SdkModal
                isOpen={isOpenModal}
                selected={selectedItem}
                onClose={handleClose}
                onCancel={handleClose}
                onApply={handleApply}
                options={filter.options}
                value={value}
            />

            {value && value?.length > 0
                ? value?.map((sdk: IAppsSDKsFilterItem, i) => (
                      <>
                          {i > 0 ? <StyledSDKValueDivider>{operatorOptionMap.and}</StyledSDKValueDivider> : null}
                          <InclusionSdkChip
                              item={sdk}
                              onEdit={handleOnEdit}
                              onDelete={handleOnDelete}
                          />
                      </>
                  ))
                : null}
        </div>
    );
};

export default AppSdkFilterResult;
